export class IrrigationResultsRow {

  date: string;                       // YYYY-MM-DD
  model_et: number;                   // liters per tree
  orchard_et_per_tree: number;        // per tree
  orchard_et_gpa: number;             // gallons per acre
  orchard_et_cumulative: number;      // gallons per acre
  rainfall_in: number;                // inches
  rainfall_gpa: number;               // gallons per acre
  rainfall_cumulative: number;        // gallons per acre
  rainfall_edited: boolean;           // value has been entered by user
  irrigation: number;                 // gallons per acre
  irrigation_cumulative: number;      // gallons per acre
  irrigation_edited: boolean;         // value has been entered by user
  irrigation_time: number;            // hours
  water_balance_daily: number;        // gallons per acre
  water_balance_cumulative: number;   // gallons per acre
  should_irrigate: boolean;           // cumulative water balance < -10000
  irrigation_recommendation: string;  // recommendation (do or do not irrigate) with time

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/models/irrigation-results-row.ts